import Ajv, { JSONSchemaType } from "ajv";

import { AppInputContextState } from "../types/context";

const ajv = new Ajv();

const contextSchema: JSONSchemaType<AppInputContextState> = {
  type: "object",
  properties: {
    mileage: { type: "number" },
    qualificationId: { type: "string" },
    vrm: { type: "string" },
    jwt: { type: "string" },
  },
  required: ["mileage", "qualificationId", "vrm", "jwt"],
  additionalProperties: true,
};

export const validateContextSchema = (data: AppInputContextState) => {
  const validate = ajv.compile(contextSchema);

  if (validate(data)) {
    return;
  } else {
    console.info(validate.errors);
    throw new Error("Schema validation error");
  }
};
